// export const BASE_API = 'https://dev.api.pompi.nl/v1/';
export const BASE_API = 'https://api.pompi.nl/v1/'; // production
// export const BASE_API = 'http://16.171.226.12:3001/v1/';
export const API = {
  LOGIN_API: BASE_API + 'auth/login',
  GET_PUMP_API: BASE_API + 'maps/gas-stations',
  SOCIAL_LOGIN_API: BASE_API + 'auth/social-login',
  GET_PROFILE_API: BASE_API + 'user/get-profile',
  UPDATE_PROFILE_API: BASE_API + 'user/update-profile',
  SIGNUP_API: BASE_API + 'auth/signup',
};

// Google Maps Platform key (Places Autocomplete, Place Details, Geocoding).
// Same key as searchFlow/SearchScreen.js.
export const GOOGLE_MAPS_API_KEY = 'AIzaSyAAqDSuVkwvg2kz78iHqAdjwMMC3q6tp-g';
